/* Copyright 2021, Milkdown by Mirone. */
import { prosePluginFactory } from '@milkdown/core';
import { commonPlugin } from './base-common';
export const createProsePlugin = (factory) => {
    const origin = (options) => {
        const plugin = prosePluginFactory((ctx) => commonPlugin(factory, ctx, options));
        plugin.origin = origin;
        return plugin;
    };
    return origin;
};
//# sourceMappingURL=base-prose-plugin.js.map